import styled from 'styled-components';

export const ItemDetailsBox = styled.div<{ $fixed?: boolean }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
    gap: 12px;
    padding: 16px;
    border: 1px solid ${({ $fixed }) => ($fixed ? 'var(--polar-green-5)' : 'var(--dust-red-4)')};
    background-color: ${({ $fixed }) => ($fixed ? 'var(--polar-green-1)' : 'var(--dust-red-1)')};
    border-radius: 6px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
`;

export const ItemDetailsField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ItemDetailsFieldLabel = styled.span`
    color: var(--gray-7);
`;
